import React, {Component} from 'react';
import {connect} from 'react-redux';
import {compose} from "redux";
import {HashRouter, Route, Switch, withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import i18n from "i18next";
import {initializeApp, setDefaultStateApp,} from "./reducers/app";
import Header from "./components/blocks/Header";
import Preloader from "./components/blocks/Preloader";
import FatalError from "./components/screens/FatalError";
import Modal from "./components/modals/Modal";
import SelectLang from "./components/modals/SelectLang";
import {getLocaleId} from "./reducers/locale-selector";
import ErrorBoundary from "./ErrorBoundary";
import {CSSTransition} from 'react-transition-group';
import StartupContainer from "./components/containers/StartupContainer";
import SettingsContainer from "./components/containers/SettingsContainer";
import CardContainer from "./components/containers/CardContainer";
import LampSettingsContainer from "./components/containers/LampSettingsContainer";

class App extends Component {
    constructor(props) {
        super(props);
        i18n.init();

        this.state = {
            keyRender: null,
            mounted: false,
        }
    }

    componentDidMount() {
        this.setState({
            keyRender: Math.random(),
            mounted: true,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps.localeId !== this.props.localeId)) this.setState({keyRender: Math.random()});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) this.setState({prevPath: this.props.location});
    }

    render() {
        let Components;

        if (!this.props.app.initialized) {
            Components = <Preloader/>
        } else if (this.props.app.errors) {
            Components = <Switch><Route path='*' exact={true} component={FatalError}/></Switch>
        } else {
            Components = <>
                <Header/>
                <Switch>
                    <Route path='/error' exact={true} component={FatalError}/>
                    <Route path='/settings' exact={true} component={SettingsContainer}/>
                    <Route path='/lamp-settings' exact={true} component={LampSettingsContainer}/>
                    <Route path='/card/:id' exact={true} component={CardContainer}/>
                    <Route path='*' exact={true} component={StartupContainer}/>
                </Switch>
                <Modal><SelectLang/></Modal>
            </>
        }

        const AnimatedSwitch = withRouter(({location}) => (
            <>
                <div className={`d-flex flex-column h-100 w-100 ${this.props.app ? this.props.app.theme_name : ''}`}>
                    <ErrorBoundary>
                        {Components}
                    </ErrorBoundary>
                </div>
            </>
        ));

        return <>
            <CSSTransition in={this.state.mounted} key={this.state.keyRender} classNames="slide" timeout={500}>
                <HashRouter keyRender={this.state.keyRender}>
                    <AnimatedSwitch/>
                </HashRouter>
            </CSSTransition>
        </>;
    }
}

const mapStateToProps = (store) => {
    return {
        app: store.appState,
        localeId: getLocaleId(store),
    }
};

export default compose(
    connect(null, setDefaultStateApp),
    connect(mapStateToProps, initializeApp)
)(withTranslation()(App));